import { render, staticRenderFns } from "./FormulaPlanList.vue?vue&type=template&id=412151dc&"
import script from "./FormulaPlanList.vue?vue&type=script&lang=js&"
export * from "./FormulaPlanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports